import React from 'react'
import { Modal } from '../../../map-editor-shared/ui/Modal'
import styles from '../EditorPage.module.css'

interface NoTypesModalProps {
  isOpen: boolean
  onClose: () => void
}

/**
 * NoTypesModal - CSV 업로드 전 객체 타입 생성 안내 모달
 *
 * CSV 파일을 업로드하기 전에 먼저 객체 타입을 생성해야 함을 알리는 경고 모달
 */
export const NoTypesModal: React.FC<NoTypesModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="객체 타입 필요"
      footer={
        <button
          className={styles.primaryButton}
          onClick={onClose}
        >
          확인
        </button>
      }
    >
      <div style={{ padding: '10px 0' }}>
        <p style={{ marginBottom: '10px' }}>
          CSV 파일을 업로드하기 전에 먼저 객체 타입을 생성해야 합니다.
        </p>
        <p style={{ color: 'var(--local-text-secondary)', fontSize: '14px' }}>
          좌측 사이드바에서 객체 타입을 추가하거나 JSON 파일을 임포트해주세요.
        </p>
      </div>
    </Modal>
  )
}
